export enum StampSignatureType {
	NotAllowed = 0,
	Required = 1,
	Allowed = 2,
}
